/**
 * API Constants
 * Stores information related to application API calls.
 */
export const APIConstants = Object.freeze({
    URLS: {
        BASE: `${process.env.REACT_APP_API_BASE_URI}`,
        RPC: {
            ETHEREUM: `${window.location.origin}/${process.env.REACT_APP_API_BASE_URI}/rpc/ethereum`
        },
        MATERIAL: {
            BASE: `${process.env.REACT_APP_API_BASE_URI}/material`
        }
    }
})